import { getToken } from '../../../utils/auth';
import { dev_baseUrl } from '../../../utils/var';
import { ToastContainer, toast } from 'react-toastify';

export const SaveCompanySettings = async (settings) => {
  const accesstoken = getToken();
  if (!accesstoken) {
    console.warn('Access token is not available.');
    return;
  }

  try {
    const response = await fetch(`${dev_baseUrl}/CompanySettings/save`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accesstoken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(settings),
    });
    const data = await response.json();

    if (response.ok && !data.isError) {
      toast.success('Company settings saved successfully', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return data;
    } else {
      toast.error(data.message || 'Error saving company settings', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return data;
    }
  } catch (error) {
    console.error('API Error on saving company settings:', error);
    toast.error('API Error on company settings', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
       theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
    });
  }
};


export const SaveSalesTax = async (tax, isEdit = false) => {
  const accesstoken = getToken();
  if (!accesstoken) {
    console.warn('Access token is not available.');
    return;
  }

  try {
    const response = await fetch(`${dev_baseUrl}/CompanySettings/SaveSalesTax`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accesstoken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(tax),
    });
    const data = await response.json();

    if (response.ok && !data.isError) {
      toast.success(
        isEdit ? 'Sales tax updated successfully' : 'Sales tax rate saved successfully',
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
           theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        }
      );
      return data;
    } else {
      toast.error(data.message || 'Error saving sales tax rate', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return data;
    }
  } catch (error) {
    console.error('API Error on saving sales tax rate:', error);
    toast.error('API Error on sales tax', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
       theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
    });
  }
};



export const GetCompanySettings = async () => {
  const accesstoken = getToken();
  if (!accesstoken) {
    console.warn('Access token is not available.');
    return null;
  }

  try {
    const response = await fetch(`${dev_baseUrl}/CompanySettings/get`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accesstoken}`,
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
  
    if (response.ok && !data.isError) {
      return data;
    } else {
      console.error('Server error fetching company settings:', data);
      return null;
    }
  } catch (error) {
    console.error('Network error fetching company settings:', error);
    return null;
  }
};

export const GetSalesTaxes = async (salesTaxID = 0) => {
  const accesstoken = getToken();
  if (!accesstoken) {
    console.warn('Access token is not available.');
    return null;
  }

  try {
    const response = await fetch(`${dev_baseUrl}/CompanySettings/GetSalesTax/${salesTaxID}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accesstoken}`,
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();

    if (response.ok && !data.isError) {
      return data;
    } else {
      console.error('Server error fetching sales taxes:', data);
      return null;
    }
  } catch (error) {
    console.error('Network error fetching sales taxes:', error);
    return null;
  }
};

export const DeleteSalesTax = async (salesTaxID) => {
  const accesstoken = getToken();
  if (!accesstoken) {
    console.warn('Access token is not available.');
    return;
  }

  try {
    const response = await fetch(`${dev_baseUrl}/CompanySettings/DeleteSalesTax/${salesTaxID}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${accesstoken}`,
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();

    if (response.ok && !data.isError) {
      toast.success('Sales tax rate deleted successfully', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return data;
    } else {
      toast.error(data.message || 'Error deleting sales tax rate', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return data;
    }
  } catch (error) {
    console.error('API Error on deleting sales tax rate:', error);
    toast.error('API Error on sales tax', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
       theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
    });
  }
};
